export default __webpack_public_path__ + "img/sabira_logo_full.17cd0571.svg";